/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function FbLogo(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'FbLogo',
      'aria-hidden': true,
      focusable: false,
      width:  16 * scale,
      height: 16 * scale,
      viewBox: '0 0 16 16',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('path', {"d":"M15.116 0H.884A.884.884 0 0 0 0 .884v14.232c0 .488.396.884.884.884H8V9.825H6V7.39h1.99V5.615c0-2.07 1.76-3.194 3.605-3.194.418 0 1.22.03 2.405.08V5h-1.774C11.224 5 11 5.5 11 6.2v1.202h2.812L13.5 9.825H11V16h4.116a.884.884 0 0 0 .884-.884V.884A.884.884 0 0 0 15.116 0","fill":"currentColor"}))
}
